<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <span class="nwit-office">
                <p class="display-1">{{ $t('office' )}}</p>
                Network IT ApS<br>
                Hostrupsvej 2, 1. tv.<br>
                DK 1950 Frederiksberg C<br>
                T +45 2222 3701<br>
                kontakt@network-it.dk<br>
                &nbsp;<br>
                <p>CVR 25384490</p>
            </span>
            <span class="hidden-sm-and-down">
                <iframe align="center" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.4152434477555!2d12.53277621618092!3d55.68176810493547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465253bb0db82d75%3A0xe913196c55a1f07f!2sHostrupsvej%202%2C%201950%20Frederiksberg!5e0!3m2!1sen!2sdk!4v1572813606290!5m2!1sen!2sdk" width="400" height="300" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </span>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "ContactPage"
    }
</script>

<style scoped>
    .nwit-office {
        margin: 1em;
    }
</style>